module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/ultilities.component.css
// module id = ./src/app/ultilities/ultilities.component.css
// module chunks = main